module.exports = __webpack_public_path__ + "img/Character_Venti_Thumb.6abb3b52.png";